import { VenueNotice } from "common/types";
import { Info } from "phosphor-react";
import React from "react";

interface NoticesTopViewProps {
  businessNotices: VenueNotice[];
  onOpenDetailModal: () => void;
}

const NoticesTopView = ({
  businessNotices,
  onOpenDetailModal,
}: NoticesTopViewProps) => {
  if (!businessNotices || businessNotices.length === 0) {
    return null;
  }

  // Calculate notice counts
  const noticeCount = businessNotices.filter(
    (n) => n.type === "Notice"
  ).length;
  const initiativeCount = businessNotices.filter(
    (n) => n.type === "Initiative"
  ).length;

  // Build notice type message
  const parts = [];
  if (noticeCount > 0)
    parts.push(`${noticeCount} Notice${noticeCount !== 1 ? "s" : ""}`);
  if (initiativeCount > 0)
    parts.push(
      `${initiativeCount} Initiative${initiativeCount !== 1 ? "s" : ""}`
    );
  const noticeTypeMessage = parts.join(", ");

  return (
    <section className="mb-4">
      <div className="bg-primary-50 dark:bg-[#313A71] border border-primary-200 rounded-xl p-3">
        <div className="flex">
          {/* Icon column */}
          <div className="flex-shrink-0 mr-3">
            <Info
              size={28}
              className="!text-primary-500 dark:!text-primary-300"
            />
          </div>

          {/* Content column */}
          <div className="flex-1">
            {/* Notice count */}
            <div className="mb-1">
              <span className="paragraph-small-semibold text-primary-800 dark:text-primary-50">
                {noticeTypeMessage}
              </span>
            </div>

            {businessNotices.length === 1 ? (
              // Single notice view
              <div className="flex flex-col space-y-1">
                <div className="flex items-start">
                  <p className="paragraph-small-medium text-primary-800 dark:text-primary-50">
                    {businessNotices[0].title}
                    {businessNotices[0].sub_title && (
                      <span className="ml-2">
                        ({businessNotices[0].sub_title})
                      </span>
                    )}
                  </p>
                </div>
                <p className="paragraph-small-medium text-primary-800 dark:text-primary-50 line-clamp-2">
                  {businessNotices[0].description.length > 120
                    ? `${businessNotices[0].description.substring(0, 120)}...`
                    : businessNotices[0].description}
                </p>
              </div>
            ) : (
              // Multiple notices view
              <div className="flex flex-col">
                <p className="paragraph-small-medium text-primary-800 dark:text-primary-50 line-clamp-2">
                  {businessNotices
                    .map((notice) => notice.title)
                    .join(", ")}
                </p>
              </div>
            )}

            <button
              onClick={onOpenDetailModal}
              className="text-primary-500 dark:text-primary-300 paragraph-small-semibold text-left mt-1"
            >
              View announcement details
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoticesTopView; 